import React, { useMemo, useEffect } from 'react';
import { Stepper } from '@shared/components/Stepper';
import { useNavigate } from 'react-router-dom';
import { useFormCompletionTracker } from '@shared/hooks/useFormCompletionTracker';
import { PageHeader } from '@shared/components/PageHeader';

import { SelectRecords } from './steps/SelectRecords';
import { ChooseFields } from './steps/ChooseFields';
import { SetNewValues } from './steps/SetNewValues';
import { ReviewApply } from './steps/ReviewApply';
import { ArrowLeft } from 'lucide-react';
import { useRemoteUtilityId } from '@shared/selectors/globalSelectors';

export const BulkEditStepper: React.FC = () => {
  const remoteUtilityId = useRemoteUtilityId();
  const storageKey = `rate-bulk-edit-progress-${remoteUtilityId}`;
  const { startTracking, logTimeUntilStep, stopTracking } = useFormCompletionTracker("BulkEditRate");
  const navigate = useNavigate();

  // useEffect(() => {
  //   const handlePopState = () => {
  //     if (!window.location.hash) {
  //       navigate("/onboarding/plan-rates", { replace: true });
  //     }
  //   };
  //   window.addEventListener("popstate", handlePopState);
  //   return () => window.removeEventListener("popstate", handlePopState);
  // }, [navigate]);

  useEffect(() => {
    startTracking()
  }, [startTracking])

  // Clear data when navigating away from this component (unmount)
  useEffect(() => {
    return () => {
      localStorage.removeItem(storageKey);
    };
  }, [storageKey]);

  const steps = useMemo(
    () => [
      {
        title: "Select Records",
        slug: "select-records",
        component: (
          <SelectRecords
            storageKey={storageKey}
            logTimeUntilStep={logTimeUntilStep}
          />
        ),
        optional: false,
      },
      {
        title: "Choose Fields to Edit",
        slug: "choose-fields",
        component: (
          <ChooseFields
            storageKey={storageKey}
            logTimeUntilStep={logTimeUntilStep}
          />
        ),
        optional: false,
      },
      {
        title: "Set New Values",
        slug: "set-new-values",
        component: (
          <SetNewValues
            storageKey={storageKey}
            logTimeUntilStep={logTimeUntilStep}
          />
        ),
        optional: false,
      },
      {
        title: "Review & Apply",
        slug: "review-apply",
        component: (
          <ReviewApply
            storageKey={storageKey}
            logTimeUntilStep={logTimeUntilStep}
            stopTracking={stopTracking}
          />
        ),
        optional: false,
      },
    ],
    [storageKey, logTimeUntilStep, stopTracking]
  );

  return (
    <div>
      <PageHeader 
        title="Bulk Edit Rates"
        subtitle="Update multiple tariff configurations at once."
        icon={ArrowLeft}
        onIconClick={() => navigate('/plan-tarrif/plan-tarrif-landing?tab=tariff')}
      />

      <Stepper
        steps={steps}
        onStepChange={() => {}}
        onStepSave={async (stepIndex, stepData, isDirty) => {
          // Storage is handled at component level using step helpers
        }}
        enableApiSave={false}
        saveOnStepChange={false}
        trackDirtyState={false}
        autoSave={true}
        persistProgress={true}
        allowSkip={false}
        storageKey={storageKey}
        enableRouting={true}
        onValidation={undefined}
        onComplete={() => {}}
        showDraftResume={true}
        className='mt-4'
      />
    </div>
  );
};
